import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [
  FETCH_MARKETABLE_LOCATIONS,
  FETCH_MARKETABLE_LOCATIONS_SUCCESS,
  FETCH_MARKETABLE_LOCATIONS_FAILURE,
] = createRequestConstantNames(cc('FETCH_MARKETABLE_LOCATIONS'));
